module.exports = __webpack_public_path__ + "img/Dantam Makeover 22.96077213.jpg";